export default __webpack_public_path__ + "static/media/Vector-3.a9f24ec6.svg";